import { ECountry } from '@/shared/enum/country.enum'
import {
  MANDATORY_BILLING_PACKAGE_VALUE,
  MINIMUM_AMOUNT_OF_PHONE_CREDITS
} from '@/shared/constants/common.constants'
import { useAppStore } from '@/stores/app'
import { useBalanceStore } from '@/stores/balance'
import { useToken } from '@/shared/composables/useToken'
import { EProfileType } from '@/shared/enum/profile-type.enum'

export const isMandatoryBilling = (country: ECountry, valuePackage: number) => {
  return country === ECountry.GT && valuePackage >= MANDATORY_BILLING_PACKAGE_VALUE
}

export const showAlwaysPhoneCreditsButtonRule = () => {
  const { profileType } = useToken()
  const store = useAppStore()
  return (
    (store.country === ECountry.CR && profileType.value === EProfileType.HYBRID) ||
    profileType.value === EProfileType.HYBRID_FU
  )
}

export const clientHasMinimumPhoneCreditsRequired = () => {
  const { balance } = useBalanceStore()
  return balance.mainBalance! >= MINIMUM_AMOUNT_OF_PHONE_CREDITS
}
